import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css'
import '@/style/main.css'
import { Notify } from 'vant';
Vue.use(Vant)
Vue.use(Notify);
// import { List } from 'vant'
// Vue.use(List)

Vue.config.productionTip = false

//开发环境
// axios.defaults.baseURL = 'http://192.168.0.118:83/engineering/'

// 测试环境
// axios.defaults.baseURL = 'http://192.168.0.118:84/engineeringt/'
// Vue.prototype.downloadUrl = 'https://dsapk.oss-cn-hangzhou.aliyuncs.com/apk/test/得盛智帮.apk'

// 预发布
// axios.defaults.baseURL = "https://wx.dslwpt.com/engineeringt/";
// Vue.prototype.journal = "https://wx.dslwpt.com";
// Vue.prototype.downloadUrl = 'https://dsapk.oss-cn-hangzhou.aliyuncs.com/apk/test/得盛智帮.apk'

//生产环境
axios.defaults.baseURL = 'https://api.dslwpt.com/dadmin/'
Vue.prototype.downloadUrl = 'https://dsapk.oss-cn-hangzhou.aliyuncs.com/apk/prod/得盛智帮.apk'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
